<script setup lang="ts">
import ErrorPage from '@/modules/App/ErrorPage.vue'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
</script>

<template>
  <ErrorPage
    title="The case you are looking for does not exist"
    message="You can create a new one or see all of your existing cases."
  >
    <template #actions>
      <div class="flex grow flex-col items-center justify-center gap-2">
        <DarwinButton
          class="w-[180px]"
          variant="black"
          size="md"
          rounded
          :to="{ name: 'NewCase' }"
        >
          <template #leading-icon>
            <IconSprite icon="plus" />
          </template>
          Start new case
        </DarwinButton>
        <DarwinButton
          class="w-[180px]"
          variant="neutral"
          size="md"
          rounded
          :to="{ name: 'WorkspaceCases' }"
        >
          <template #leading-icon>
            <IconSprite icon="templates" />
          </template>
          View all cases
        </DarwinButton>
      </div>
    </template>
  </ErrorPage>
</template>
